import { Building, MapPin, Globe } from 'lucide-react';
import { useProfile } from '../../../../../context/profile/ProfileContext';

const AccountBusinessSection = () => {
  const {
    formData,
    handleInputChange,
    isEditing,
    renderInput
  } = useProfile();

  return (
    <div className="pt-2">
      <div className="border-b border-slate-100 pb-2.5 mb-4">
        <h2 className="font-semibold text-slate-900 text-base">Business details</h2>
        <p className="text-xs text-slate-500 mt-0.5 font-normal">Company information &amp; location</p>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {renderInput("Company Name", "business_name", formData.business_name, "text", !isEditing, Building, false, true)}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {renderInput("City", "city", formData.city, "text", !isEditing, MapPin, false, true)}
          {renderInput("Pin Code", "pincode", formData.pincode, "text", !isEditing, Globe, false, true)}
        </div>
        <div className="space-y-1.5">
          <label className="block text-xs font-semibold text-slate-700 tracking-wide mb-1.5">
            Work Address {isEditing && <span className="text-rose-500 ml-0.5">*</span>}
          </label>
          <textarea
            name="address"
            value={formData.address}
            onChange={handleInputChange}
            disabled={!isEditing}
            rows="3"
            className={`w-full px-4 py-2.5 rounded-xl border text-sm font-medium focus:outline-none focus:ring-2 focus:ring-[#067978]/20 focus:border-[#067978] transition-all resize-none ${
              isEditing ? 'bg-white border-slate-200 text-slate-800' : 'bg-slate-50 border-slate-200 text-slate-500 cursor-not-allowed'
            }`}
          />
        </div>
      </div>
    </div>
  );
};

export default AccountBusinessSection;
